import Axios from "axios";
import { Routes } from "../constant/api_url";
import trimRequestPayload from "../utils/trimInput";

export const axios = Axios.create({
  baseURL: Routes.API_HOSTNAME,
  timeout: 1000000000,
  responseType: "json"
});

axios.interceptors.request.use(
  async (config) => {
    config.headers.authorization = `Bearer ${JSON.parse(
      localStorage.getItem("token")
    )}`;
    config.headers.call_type = 'PANEL';

    // Trim every string on its way out, so a search term or a form value is
    // sent exactly as typed. Mirrors the backend's trimRequestInput middleware —
    // this one covers the many pages that filter lists in memory client-side,
    // the server one is the guarantee. FormData / Blob / raw strings pass
    // through untouched (see utils/trimInput).
    if (config.params) config.params = trimRequestPayload(config.params);
    if (config.data) config.data = trimRequestPayload(config.data);

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error?.response?.status === 401) {
      localStorage.clear();
      window.location.replace("/");
    }
    return Promise.reject(error);
  }
);

export default axios;
